export default __webpack_public_path__ + "static/media/expressjs.bd60c4de.png";